let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("kFWZh")).then(() => parcelRequire('8Gg0l'));